"use client";

import { type Table as ReactTableType } from "@tanstack/react-table";
import { ActionIcon, Box, Flex, Grid, Text } from "rizzui";
import { PiCaretLeftBold, PiCaretRightBold } from "react-icons/pi";
import React, { ReactNode, useEffect, useState } from "react";
import cn from "../../lib/utils/class-name";
import { useLocation } from "react-router";

export default function TablePagination({
  className,
  pageClassName,
  tableLength = 0,
  setPage,
}: {
  className?: string;
  pageClassName?: string;
  tableLength?: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}) {
  const pagination = (c, m) => {
    var current = c,
      last = m,
      delta = 1,
      left = current - delta,
      right = current + delta + 1,
      range: any[] = [],
      rangeWithDots: any[] = [],
      l;

    for (let i = 1; i <= last; i++) {
      if (i == 1 || i == last || (i >= left && i < right)) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [pages, setPages] = useState<any>(pagination(currentPage, tableLength));
  const location = useLocation().pathname.replace("/", "");

  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    setPages(pagination(currentPage, tableLength));
    setPage(currentPage);
  }, [currentPage]);

  return (
    <div className="flex flex-row justify-start md:justify-center items-center h-[30px] mt-[12px]">
      {location !== "dashboard" && (
        <Flex
          align="center"
          justify="center"
          className={cn(
            "@container gap-[12px] w-[80%] md:w-[326px] h-[30px]",
            className
          )}
        >
          <ActionIcon
            variant="text"
            className="text-[#758599] hover:text-[#758599]"
            disabled={currentPage <= 1}
            onClick={handlePrevious}
          >
            <PiCaretLeftBold />
          </ActionIcon>
          <Flex
            align="center"
            justify="center"
            className={cn("@container gap-[6px] md:gap-[10px]", pageClassName)}
          >
            {pages.map((page, index) => {
              return page !== "..." ? (
                <ActionIcon
                  variant="text"
                  className={cn(
                    "bg-background hover:bg-btn hover:text-background text-primary-dark rounded-[5px] size-[25px] md:size-[30px] font-switzer font-[400] text-[14px] md:text-[17.5px] leading-[23.1px]",
                    page === currentPage ? "bg-btn text-background" : ""
                  )}
                  key={index}
                  onClick={(e) => setCurrentPage(page)}
                >
                  {page}
                </ActionIcon>
              ) : (
                <Text key={index}>{page}</Text>
              );
            })}
          </Flex>
          <ActionIcon
            variant="text"
            className="text-[#758599] hover:text-[#758599]"
            disabled={currentPage === tableLength}
            onClick={handleNext}
          >
            <PiCaretRightBold />
          </ActionIcon>
        </Flex>
      )}
    </div>
  );
}
